// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "flight-wOECR";
var _4 = "selectType-3Rs5p";
var _5 = "segment-3y1Hp";
var _6 = "transfer-25al1";
var _7 = "last-2WYfG";
var _8 = "selected-ex3nA";
var _9 = "flightNumber-3A3BR";
var _a = "timeInRoute-2qVFs";
var _b = "stopsInfo__stop-3-O5e";
var _c = "stopsInfo__label-3RV3S";
var _d = "checkinCard-1eJdp";
export { _1 as "__esModule", _2 as "mobile", _3 as "flight", _4 as "selectType", _5 as "segment", _6 as "transfer", _7 as "last", _8 as "selected", _9 as "flightNumber", _a as "timeInRoute", _b as "stopsInfo__stop", _c as "stopsInfo__label", _d as "checkinCard" }
export default { "__esModule": _1, "mobile": _2, "flight": _3, "selectType": _4, "segment": _5, "transfer": _6, "last": _7, "selected": _8, "flightNumber": _9, "timeInRoute": _a, "stopsInfo__stop": _b, "stopsInfo__label": _c, "checkinCard": _d }
